import * as React from 'react';
import { DialogTitle, DialogContent, TextField, DialogActions, Button, Select, MenuItem, FormControl } from '@material-ui/core';
import { CanvasItem } from './Canvas';
import { Guid } from 'guid-typescript';


export default class CanvasItemForm extends React.Component<ICanvasItemFormProps, ICanvasItemFormState> {

    constructor(props: ICanvasItemFormProps) {
        super(props);
        this.state = {
            Item:
                this.props.Item ?
                    this.props.Item
                    :
                    {
                        Id: Guid.create().toString(),
                        Status: 0,
                        Title: '',
                    } as CanvasItem
            // Comments: this.props.Comments ? this.props.Comments : ''
        };
    }

    public render() {
        return (
            <div>
                <DialogTitle id="form-dialog-title">
                    {this.props.Item && this.props.Item.Title ? "Edit " : "New "}
                    {this.props.SectionDisplayName}
                    {/* {this.props.Id} */}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        onChange={(e) => {
                            const i = this.state.Item;
                            i.Title = e.target.value;
                            this.setState({ Item: i });
                        }}
                        value={this.state.Item.Title}
                        autoFocus={true}
                        type="text"
                        multiline={false}
                        rowsMax="4"
                        fullWidth={true}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                this.props.onSave(this.props.Section, this.state.Item)
                            }
                        }}
                    />
                    <br /><br />
                    <div style={{ marginLeft: '5px' }}>
                        <FormControl>
                            <Select
                                value={this.state.Item.Status}
                                onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
                                    const i: CanvasItem = this.state.Item;
                                    i.Status = event.target.value as number;
                                    this.setState({ Item: i });
                                }}
                                inputProps={{
                                    name: 'Validated',
                                    id: 'Validated',
                                }}
                            >
                                <MenuItem value={0}>Not validated</MenuItem>
                                <MenuItem value={1}>Validated</MenuItem>
                                <MenuItem value={2}>Big nope</MenuItem>
                            </Select>
                            {/* <FormHelperText>Some important helper text</FormHelperText> */}
                        </FormControl>
                    </div>


                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        Cancel
          </Button>
                    {this.props.Item &&
                        <Button onClick={() => {
                            const i = this.state.Item;
                            i.Title = "";
                            // this.setState({ Item: i });
                            this.props.onSave(this.props.Section, i);
                        }
                        } color="secondary">
                            Delete
          </Button>
                    }
                    <Button onClick={() => this.props.onSave(this.props.Section, this.state.Item)} color="primary">
                        Save
          </Button>
                </DialogActions>
            </div>
        );
    }
}

interface ICanvasItemFormProps {
    Section: string;
    SectionDisplayName: string;
    Item?: CanvasItem;
    // Comments?: string;
    onClose: () => void;
    onSave: (section: string, item: CanvasItem) => void;
}

interface ICanvasItemFormState {
    Item: CanvasItem;


    // Comments: string;
}


// WEBPACK FOOTER //
// ./src/components/canvas/CanvasItemForm.tsx